import { i18n } from "@/lib/i18n";

/**
 * The greeting for the hour (0-23), in the dashboard's language: "Goedemorgen"
 * before noon, "Goedenamiddag" until six, then "Goedenavond" (in French
 * "Bonjour" until six, then "Bonsoir").
 */
export function greeting(hour: number): string {
  if (hour < 12) {
    return i18n.t("home.morning");
  }
  return hour < 18 ? i18n.t("home.afternoon") : i18n.t("home.evening");
}
